import { render, staticRenderFns } from "./select-service-category.vue?vue&type=template&id=7a4a13b4&"
import script from "./select-service-category.vue?vue&type=script&lang=js&"
export * from "./select-service-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports